import React, {useEffect} from 'react'
import Translation from '../global/Translation'

import classNames from 'classnames';
import createClass from 'create-react-class'
import { connect } from 'react-redux'
import {
    getCurrentSegmentation,
    getSelectedChannel,
    getSelectedSalesForceId,
    getSelectedProjectId,
    getProjectIdV3, getNexusEnvironment, getNexusUse, getMaterialProjects
} from '../../store/segmentation/reducers'
import {
    toggleSegmentation,
    selectProjectIdV4,
    selectTypology,
    selectUse
} from '../../store/segmentation/actions'
import Select, {Option} from 'react-select'
import {isOptionalBuilderProjectCenter} from "../../store/centers/reducers";
import PropTypes from "prop-types";
import InfoWithToolTip from "../global/InfoWithToolTip";

const mapStateToProps = (state, props) => {
    const channel = getSelectedChannel(state)
    const salesForceId = getSelectedSalesForceId(state)

    return {
        show: getCurrentSegmentation(state) === 'SUBCHANNEL',
        selected: getSelectedProjectId(state),
        options: getProjectIdV3(state, channel, salesForceId, props.inProfile),
        isOptionalBuilderProjectCenter: isOptionalBuilderProjectCenter(state),
        nexusEnvironment: getNexusEnvironment(state),
        nexusUse: getNexusUse(state),
        materialProjects: getMaterialProjects(state),
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onToggle: () => {
            dispatch(toggleSegmentation('SUBCHANNEL'))
        },
        onSelect: (value, name, subchannelProgram, businessSegment, subchannelId, salesForceId, salesForceName, originalChannel, originalChannelName) => {
            dispatch(selectProjectIdV4(value, name, subchannelProgram, businessSegment, subchannelId, salesForceId, salesForceName, originalChannel, originalChannelName))
        },
        selectTypology: nexusEnvironment => {
            const envValue = nexusEnvironment && nexusEnvironment.id
            const envVName = nexusEnvironment && nexusEnvironment.name
            dispatch(selectTypology(envValue, envVName))
        },
        selectUse: nexusUse => {
            const useValue = nexusUse && nexusUse.id
            const useVName = nexusUse && nexusUse.name
            dispatch(selectUse(useValue, useVName))
        }
    }
}

const CustomOption = createClass({
    propTypes: Option.propTypes,
    handleMouseDown(event) {
        event.preventDefault()
        event.stopPropagation()
        if (!this.props.isDisabled) this.props.onSelect(this.props.option, event)
    },
    handleMouseEnter(event) {
        this.props.onFocus(this.props.option, event)
    },
    handleMouseMove(event) {
        if (this.props.isFocused) return
        this.props.onFocus(this.props.option, event)
    },
    render() {
        return (
            <div
                className={this.props.className}
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                title={this.props.option.title}
            >
                {this.props.children}
                {this.props.isDisabled &&
                    <div className="info_with_tool_tip">
                        <Translation id="not_available" defaultMessage="Not available"/>
                    </div>
                }
            </div>
        )
    }
})




class ProjectIdV3 extends React.Component {

    componentDidMount() {
        this.props.selectTypology(this.props.nexusEnvironment)
        this.props.selectUse(this.props.nexusUse)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.selected !== prevProps.selected) {
            this.props.selectTypology(this.props.nexusEnvironment)
            this.props.selectUse(this.props.nexusUse)
        }
    }

    render() {
        const { selected, onSelect, options, materialProjects, intl } = this.props
        if (options === undefined) {
            return ''
        }
        const _options = options && Object.entries(options)
        if (_options && (_options.length === 0 /*|| (_options.length === 1 && !_options[0][1].projectId)*/)) {
            return ''
        }

        // console.log('OPTIONS' , _options)
        // console.log('SELECTED > ' , this.props.selected, this.props.nexusEnvironment, this.props.nexusUse)

        return (
            <div>
                <div className="segmentation-segment-title">
                    <Translation id="choose_project" defaultMessage="Choose project" />
                    {!this.props.isOptionalBuilderProjectCenter && <span>*</span>}:
                </div>

                <Select
                    placeholder={intl.formatMessage({ id: 'choose_option' })}
                    options={_options.map(option => ({
                        label: option[1].projectName === '' ? 'PROJECT' : option[1].projectName,
                        value: option[0],
                        disabled: option[1].subchannelId === 'NX' && !materialProjects.has(option[1].projectId),//solo para Nexus
                        subchannelProgram: option[1].subchannelProgram ? option[1].subchannelProgram : null,
                        businessSegment: option[1].businessSegment ? option[1].businessSegment : null,
                        subchannelId: option[1].subchannelId ? option[1].subchannelId : null,
                        originalChannel: option[1].originalChannel ? option[1].originalChannel : null,
                        originalChannelName: option[1].originalChannelName ? option[1].originalChannelName : null,
                        salesForceId: option[1].salesForceId ? option[1].salesForceId : null,
                        salesForceName: option[1].salesForceName ? option[1].salesForceName : null
                    }))}

                    value={selected}
                    onChange={option => option && onSelect(
                        option.value,
                        option.label,
                        option.subchannelProgram,
                        option.businessSegment,
                        option.subchannelId,
                        option.salesForceId,
                        option.salesForceName,
                        option.originalChannel,
                        option.originalChannelName
                    )}
                    clearable={false}
                    optionComponent={CustomOption}

                />
                {/* <hr /> */}
            </div>
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectIdV3)
